<block-ui></block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="PublicHolidayForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="PublicHolidayForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <button type="button" title="Add" class="btn btn-sm btn-primary me-3" (click)="showAddPublicHolidayModal(AddPublicHolidayModal)">
            <i class="me-1 fas fa-plus"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>
          <button type="button" title="{{utilityService.getResourceValue('PublicHolidaysCreateUAE')}}" class="btn btn-sm btn-light-primary me-3 " (click)="showGenerateUAEPublicHolidayModal(GenerateUAEPublicHolidaysModal)">
            <i class="me-1 fa fa-calendar-alt"></i>
            {{utilityService.getResourceValue('PublicHolidaysCreateUAE')}}
          </button>
          <!-- end::Menu -->
        </div>
      </div>
      <!-- end::Header -->
      <!-- begin::Body -->
      <div class="card-body py-3">
        <div class="table-responsive">
          <!-- begin::Table -->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Country")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Date")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Status")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let PublicHoliday of PublicHolidayPagingResult">
                <td>
                  <div class="text-dark" *ngIf="language=='en'">{{PublicHoliday.name.english}}</div>
                  <div class="text-dark" *ngIf="language=='ar'">{{PublicHoliday.name.arabic}}</div>
                </td>
                <td>{{PublicHoliday.countryName}}</td>
                <td>{{PublicHoliday.date}}</td>
                <td>
                  <span class="badge badge-light-primary" *ngIf="PublicHoliday.isActive;else other_content">
                    {{utilityService.getResourceValue("Active")}}
                  </span>
                  <ng-template #other_content>
                    <span class="badge badge-light-danger">
                      {{utilityService.getResourceValue("Inactive")}}
                    </span>
                  </ng-template>
                </td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button class="drop-item px-3" ngbDropdownItem
                              (click)="showEditPublicHolidayModal(PublicHoliday, EditPublicHolidayModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </button>
                      <button ngbDropdownItem class="drop-item px-3" id="btnResetPass"
                              (click)="showDeletePublicHolidayModal(PublicHoliday , deletePublicHolidayModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </button>
                    </mat-menu>
                  </div>

                </td>
              </tr>
              <tr *ngIf="PublicHolidayPagingResult.length == 0">
                <td colspan="5">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setPublicHolidayListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="PublicHolidayPaging" [group]="PublicHolidayForm" #PublicHolidayPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>


  <!--add Modal-->
  <ng-template #AddPublicHolidayModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("PublicHoliday")}}</h1>
      </div>
      <form [formGroup]="AddPublicHolidayForm"
            (ngSubmit)="addPublicHoliday()">
        <div class="row" *ngIf="!ProductionMode">
          <div class="col-md-12">
            <BBSF-TextBox [options]="SysName" [group]="AddPublicHolidayForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddPublicHolidayForm"></BBSF-MultiLingualTextBox>

          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="DescriptionInEnglish" [group]="AddPublicHolidayForm">
            </BBSF-TextArea>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="DescriptionInArabic" [group]="AddPublicHolidayForm">
            </BBSF-TextArea>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="CountryOptions" [group]="AddPublicHolidayForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="DayOptions" [group]="AddPublicHolidayForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="MonthOptions" [group]="AddPublicHolidayForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="IsActive" [group]="AddPublicHolidayForm">
            </BBSF-CheckBox>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #ClosePublicHolidayModal id="ClosePublicHolidayModal" type="button"
                  class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>

        </div>
      </form>

    </div>
  </ng-template>
  <!--edit Modal-->
  <ng-template #EditPublicHolidayModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("PublicHoliday")}}</h1>
      </div>
      <form [formGroup]="EditPublicHolidayForm" (ngSubmit)="editPublicHoliday()">
        <div class="row" *ngIf="!ProductionMode">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditSysName" [group]="EditPublicHolidayForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditPublicHolidayForm"></BBSF-MultiLingualTextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="EditDescriptionInEnglish" [group]="EditPublicHolidayForm">
            </BBSF-TextArea>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="EditDescriptionInArabic" [group]="EditPublicHolidayForm">
            </BBSF-TextArea>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditCountryOptions" [group]="EditPublicHolidayForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditDayOptions" [group]="EditPublicHolidayForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditMonthOptions" [group]="EditPublicHolidayForm">
            </BBSF-DropdownList>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EditIsActive" [group]="EditPublicHolidayForm">
            </BBSF-CheckBox>
          </div>
        </div>

        <div class="text-center pt-7">
          <button #CloseEditPublicHolidayModal id="CloseEditPublicHolidayModal" type="button"
                  class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>

        </div>
      </form>

    </div>
  </ng-template>
  <!--delete Modal-->
  <ng-template #deletePublicHolidayModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("PublicHoliday")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeletePublicHolidayModal id="CloseDeletePublicHolidayModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deletePublicHoliday()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>
  
  <!-- Generate UAE public holidays  Modal -->
  <ng-template #GenerateUAEPublicHolidaysModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">
          {{utilityService.getResourceValue("PublicHolidaysCreateUAEConfirmation")}}
        </h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("PublicHolidaysCreateUAEConfirmation")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseGeneratePublicHolidayModal id="CloseGeneratePublicHolidayModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("No")}}
        </button>
        <button type="button" (click)="generateUAEPublicHoliday()"
                class="btn btn-primary btn-sm ">
          {{utilityService.getResourceValue("Yes")}}
        </button>
      </div>
    </div>
  </ng-template>
